function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import UiLayer from './UiLayer';
import Scrim from './Scrim';
/**
 * The UiLayers component is the integration point for the `@sie/web-common-layers` library.
 * The intent of the package is to manage layered UIs such that elevations (z-indexes) are
 * properly coordinated across the application. See the `@sie/web-common-layers` docs for more
 * information
 *
 * - [Web Common Layers Docs](https://github.sie.sony.com/pages/SIE/web-common-toolkit/core/layers/)
 * - [Web Common I18n Docs](https://github.sie.sony.com/pages/SIE/web-common-toolkit/core/i18n/)
 *
 * ## Composed of
 * - [UiLayer](./UiLayer/README.md)
 * - [UiLayerItem](./UiLayerItem/README.md)
 * - [Scrim](./Scrim/README.md)
 *
 * ## Usage
 *
 * ```jsx
 * <body>
 *    <header>...</header>
 *    <main>...</main>
 *    <footer>...</footer>
 *    <UiLayers
 *      getComponent={app.getComponent}
 *      format={app.format}
 *      layers={layers}
 *    />
 * </body>
 *```
 *
 * ## Props
 */

var UiLayers = /*#__PURE__*/function (_PureComponent) {
  _inherits(UiLayers, _PureComponent);

  var _super = _createSuper(UiLayers);

  function UiLayers() {
    _classCallCheck(this, UiLayers);

    return _super.apply(this, arguments);
  }

  _createClass(UiLayers, [{
    key: "makeLayer",
    value: function makeLayer(layer) {
      var getComponent = this.props.getComponent;
      var ui = layer.ui;
      if (ui) return getComponent(ui);
      return UiLayer;
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;

      var _this$props = this.props,
          format = _this$props.format,
          layers = _this$props.layers,
          getComponent = _this$props.getComponent,
          children = _this$props.children;
      return /*#__PURE__*/React.createElement(React.Fragment, null, children, layers.length && layers.map(function (layer) {
        var name = layer.name;
        var type = "".concat(name, "-layer");

        var Layer = _this.makeLayer(layer);

        if (name === 'scrim') return /*#__PURE__*/React.createElement(Scrim, {
          key: type,
          scrim: layer
        });
        return /*#__PURE__*/React.createElement(Layer, {
          qa: type,
          key: type,
          className: "psw-layer-".concat(type, " psw-l-layer"),
          layer: layer,
          format: format,
          getComponent: getComponent
        });
      }));
    }
  }]);

  return UiLayers;
}(PureComponent);

UiLayers.defaultProps = {
  format: function format() {},
  children: null
};
UiLayers.propTypes = {
  /**
   * Get a Component to render
   */
  getComponent: PropTypes.func.isRequired,

  /**
   * Function to localize text before render
   * See `@sie/web-common-i18n` for more information on the
   * expected interface
   */
  format: PropTypes.func,

  /**
   * The layers to render, see @sie/web-common-layers for API usage of layers
   */
  layers: PropTypes.arrayOf(PropTypes.shape({
    /**
     * The name of the layer
     */
    name: PropTypes.string,

    /**
     * The elevation (zIndex) for the layer
     */
    elevation: PropTypes.number,

    /**
     * Gets all items on the layer
     */
    getAll: PropTypes.func
  })).isRequired,

  /**
   * The main UI content / base layer
   */
  children: PropTypes.node
};
export default UiLayers;